<template>
  <main style="background-color: #1D1D1B;">
    <section>
      <div class="align-content-center m-4">
        <div class="page_title" style="display: flex;justify-content: center;">
          <div class="page_title" style="display: flex;justify-content: center;">
            <div>
              <h3 class="page_title" style="display: inline-block;
            height: 4.1rem;
            border-bottom: 3px solid rgb(252, 180, 46); color: rgb(252, 180, 46);">News </h3>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex; width: 100%;justify-content:right;padding-right: 15%;">
        <SearchInput v-model="inputValue" style="width: 345px;" @keyEnter="searchData" />
      </div>
      <div style=" height: 30px;background-color: #2C2C2B;text-align: left;; line-height: 30px;">

      </div>
    </section>
    <section>

      <div class="page_content" style="min-height: 800px;">
        <div>

          <div>
            <table>
              <tr>
                <td class=" col-md-1-1" style="vertical-align: top; padding: 0;background-color: #1D1D1B;">
                  <div class="tree-box" style="width: 100%;min-width: 240px;">

                    <div class="tree-content" style="margin-top: 6px;">
                      <el-tree ref="treeleft" :data="treeData" node-key="id" :indent="0" class="tree-line"
                        :row-style="{'padding-top':'0px','padding-bottom':'0px',height:'30px','line-height':'30px'}"
                        @cell-style="{color:red}" :default-expand-all="isLeftExp" :highlight-current="false"
                        :expand-on-click-node="false" @node-click="handleNodeClick">

                        <span slot-scope="{ data,node}" class="custom-tree-node"
                          :style="{ cursor: node.childNodes && node.childNodes.length > 0 ? 'not-allowed' : 'pointer' ,width:'100%','text-align':'left'}">
                          <template>
                            <div class="node_div">
                              <span class="name-box">
                                {{ data.name }}<span v-if="data.itemNum>0">({{data.itemNum}})</span>
                              </span>
                            </div>
                          </template>
                        </span>
                      </el-tree>
                    </div>
                  </div>
                </td>
                <td class="container col-md-10-1"
                  style="vertical-align: top;padding: 0;padding-left: 10%;padding-right: 15%;">
                  <section>
                    <div class=" row news_content" v-for="item in paginatedData" :key="item.id"
                      @click="navigateTo(item.id)">
                      <div class="col-md-1-1 content_padding news_content_date">
                        <div class="card-body news_content_date_body">
                          <h3> {{item.monthDay}} </h3>
                          <p>— {{item.year}} —</p>
                        </div>
                      </div>

                      <div class="col-md-7-1 content_padding">
                        <div class="overlay  border-0 text-left pb-2">
                          <h5 class="card-title news_title">{{item.title}}</h5>
                          <p class="card-text text-muted">
                            {{item.summary}}
                          </p>
                        </div>
                      </div>
                      <div class="col-md-3 content_padding">
                        <div class="overlay border-0">
                          <img class="card-img" :src="item.url" alt="Card image" style="height: 165px;width: 333px">
                        </div>
                      </div>
                    </div>
                    <div style="width: 100%;text-align: center;margin-top: 28px;margin-bottom: 50px;">
                      <el-pagination background layout="prev, pager, next" :hide-on-single-page="value"
                        :total="totalData" :page-size="pageSize" @current-change="handleCurrentChange"
                        :current-page="currentPage">
                      </el-pagination>
                    </div>

                  </section>
                </td>
              </tr>
            </table>
          </div>

        </div>
      </div>
    </section>
    <!-- 弹窗 -->
    <!-- <div v-if="dialogVisible" class="popup" style="width: 100%;height: 95%;max-width: 1000px;">

                      <div style="height: 30px;text-align: right; background-color: #262626;padding-top: 5px;">
                        <img src="/assets/img/Main/popMin.png" alt="" @click="dialogVisible = false"
                          style="margin-right: 20px;">
                        <img src="/assets/img/Main/popMax.png" alt="" @click="dialogVisible = false"
                          style="margin-right: 20px;">
                        <img src="/assets/img/Main/popExit.png" alt="" @click="dialogVisible = false"
                          style="margin-right: 20px;">

                      </div>

                      <div style="overflow: auto;max-height: 845px;">
                        <div>
                          <h3 style="display: inline-block;height: 50px;color: rgb(252, 180, 46);padding-top: 15px;">
                            News </h3>
                        </div>
                        <div v-html="currentContent" style="text-align: left;padding-left: 10px;padding-right: 10px; ">
                        </div>
                      </div>


                    </div> -->
    <!-- 弹窗 -->
    <div v-if="showModal" class="modal-overlay" @click="showModal = false">
      <div class="draggable-modal" @click.stop :style="{ top: modalTop + 'px', left: modalLeft + 'px' }"
        @mousedown="startDrag">
        <div class="modal-header">
          <h3
            style="display: inline-block;color: rgb(252, 180, 46);padding-top: 5px;width: calc(100% - 20px);text-align: center">
            {{popTitle}} </h3>
          <button @click="closeShowModal" class="close-btn">×</button>
        </div>
        <div class="modal-content">
          <div style="text-align: left;padding-left: 0.8rem;padding-top: 10px;">
            <h5>{{popSum}}</h5>
          </div>
          <div style="text-align: left;padding-left: 1.2rem;padding-top: 10px;font-size: 12px;">{{popDate}}</div>
          <div v-html="currentContent" v-lazy-base64
            style="text-align: left;padding-left: 10px;padding-right: 10px;padding-top: 20px;">
          </div>
        </div>
      </div>
    </div>
  </main>

</template>


<script>
  import SearchInput from '@/components/common/SearchInput.vue';
  import { getNewsNoContentList, getNewsTreeData, getNewsAllList } from "@/api/rbac/news";
  // import { getNewsNoContentList, getNewsTreeList } from "@/api/rbac/news";
  export default {
    name: 'News',
    components: {
      SearchInput
    },
    data() {
      return {
        inputValue: '',
        slides: [
          { date: '2022/11/24', img: require('../../../public/assets/img/News/news_primary.png'), title: '2022 LAS VEGAS AAPEX SHOW RECSP', content: 'The Las Vegas AAPEX Show, also known as the Automotive Aftermarket Products Expo, is one of the largest automotive aftermarket trade shows in the world.It brings together manufacturers, distributors, retailers, and service professionals  from the automotive aftermarket industry to showcase new peoducts, technologies and services.' },
          { date: '2023/11/24', img: require('../../../public/assets/img/News/news1.png'), title: '2023 LAS VEGAS AAPEX SHOW RECSP', content: 'The Las Vegas AAPEX Show, also known as the Automotive Aftermarket Products Expo, is one of the largest automotive aftermarket trade shows in the world.It brings together manufacturers, distributors, retailers, and service professionals from the automotive aftermarket industry to showcase new peoducts, technologies and services.' },
          { date: '2024/11/24', img: require('../../../public/assets/img/News/news2.png'), title: '2024 LAS VEGAS AAPEX SHOW RECSP', content: 'The Las Vegas AAPEX Show, also known as the Automotive Aftermarket Products Expo, is one of the largest automotive aftermarket trade shows in the world.It brings together manufacturers, distributors, retailers, and service professionalsfrom the automotive aftermarket industry to showcase new peoducts, technologies and services.' },
        ],
        // currentPage: 1,  // 当前显示的页面
        // itemsPerPage: 1,  // 每页显示3张图片
        newsData: [],
        treeData: [],
        isLeftExp: true,
        // 当前页码
        currentPage: 1,
        // 每页显示的数据条数
        pageSize: 6,
        // 总数据条数
        totalData: 0,
        value: true,
        dialogVisible: false,//新联详情弹窗
        currentContent: '',//新联详情
        currentNodeKey: 0,
        newsOriginData: [],

        popTitle: '',
        popDate: '',
        popSum: '',

        showModal: false,
        modalTop: 50,
        modalLeft: 200,
        isDragging: false,
        startX: 0,
        startY: 0,
        startModalX: 0,
        startModalY: 0
      };
    },

    created() {
      // this.getNewsTreeList();
    },
    computed: {
      // slidesgroup() {
      //   return Math.ceil(this.slides.length);
      // },
      // displayedSlides() {
      //   const start = (this.currentPage - 1) * this.itemsPerPage;
      //   const end = start + this.itemsPerPage;

      //   return this.slides.slice(start, end);
      // },
      // 计算属性，用于获取当前页的数据
      paginatedData() {
        const start = (this.currentPage - 1) * this.pageSize;
        const end = this.currentPage * this.pageSize;
        return this.newsData.slice(start, end);
      },
    },
    methods: {
      // renderContent(h, { data}) {
      //    let cursorStyle = '';
      //               if (data.disabled) {
      //                   cursorStyle = 'cursor:not-allowed;color:red;';
      //               }
      //   return h(
      //     'span',
      //     {
      //       class: { 'name-box': data.disabled},
      //       style: cursorStyle,
      //     },
      //      data.name
      //   );
      // },
      navigateTo(id) {
        if (window.innerWidth * 0.60 > 1060) {
          this.modalLeft = (window.innerWidth - 1060) / 2;
        }
        else {
          this.modalLeft = window.innerWidth * 0.40 / 2;
        }
        this.modalTop = 0;
        this.currentContent = '';
        this.popDate = '';
        this.popSum = '';
        this.popTitle = '';
        try {
          getNewsAllList({ tableType: 0, strWhere: ' and a.id=' + id }).then((res) => {
            if (res.data.length == 0) {
              this.currentContent = '';
            }
            else {
              this.currentContent = res.data[0].content;
              this.popDate = res.data[0].date.replace('T', ' ');
              this.popSum = res.data[0].summary;
              this.popTitle = res.data[0].title
            }
          });

        } catch (error) {
          console.log(error);
        }

        this.dialogVisible = true;
        this.showModal = true;
        // // console.log(`${this.$route.path}/0/` + id)
        // this.$router.push(`${this.$route.path}/0/` + id);
      },
      closeShowModal() {
        this.showModal = false;
        this.currentContent = '';
        this.popDate = '';
        this.popSum = '';
        this.popTitle = '';
      },
      // 当前页码改变时的处理函数
      handleCurrentChange(page) {
        this.currentPage = page;
      },
      setDefaultNode(id) {
        // 假设你想默认聚焦的节点的 id 是 5
        this.$nextTick(() => {
          const tree = this.$refs.treeleft;
          const node = tree.getNode(id);

          if (node) {
            tree.setCurrentKey(id);
            // this.loadDataList(` and a.year='${node.data.realID}'`)
            // //tree.setCurrentNode(node); // 可选，根据需求选择是否使用
            this.loadDataList(node)
          }
        });
      },
      handleNodeClick(node) {
        if (node.children.length > 0) {
          // 阻止默认行为
          event.stopPropagation();
          this.$nextTick(() => {
            this.$refs.treeleft.setCurrentKey(this.currentNodeKey);
            document.activeElement.blur();
          });
          return;
        }
        this.currentNodeKey = node["id"];
        if (node.pID == 0) {
          this.loadDataList('')
        }
        else {
          // this.loadDataList(` and a.year='${node.realID}'`)
          this.loadDataList(node)
        }
      },
      getNewsTreeList() {
        // getNewsTreeList({ tableType: 0, strWhere: '' }).then(res => {
        //   this.treeData = res.data;
        //   if (this.treeData.length > 0 && this.treeData[0].children.length > 0) {
        //     this.$nextTick(() => {
        //       this.$refs.treeleft.setCurrentKey(this.treeData[0].id);
        //     });
        //   }
        //   // this.setDefaultNode(4)
        //   this.loadDataList('')

        // })
        getNewsTreeData({ strWhere: '' }).then(res => {
          this.treeData = res.data;
          var node;
          if (this.treeData.length > 0 && this.treeData[0].children.length > 0) {
            this.$nextTick(() => {
              node = this.treeData[0].children[0]
              this.$refs.treeleft.setCurrentKey(node.id);
              this.currentNodeKey = node.id;
            });
          }
          //  this.setDefaultNode(1)
          this.loadDataList('')

        })
      },


      async loadDataList(node) {
        this.currentPage = 1;
        this.newsOriginData = [];
        try {
          getNewsNoContentList({ tableType: node["realID"], strWhere: '' }).then(res => {
            this.totalData = res.data.length;
            if (res.data.length == 0) {
              // console.log(this.dataList)
              this.newsData = [];
            }
            else {
              this.newsData = res.data;
              this.newsData.forEach(comNew => {
                comNew.url = "../../../assets/img/News/" + comNew.url;
              });
            }

          })
        } catch (error) {
          console.error('获取失败:', error);
        }
      },
      searchData(value) {
        if (this.newsOriginData.length == 0) {
          this.newsOriginData = this.newsData
        }
        if (value.length == 0) {
          this.newsData = this.newsOriginData
          this.newsOriginData = []
        }
        else {
          this.newsData = this.newsOriginData.filter(product => product.title.toLowerCase().includes(value.toLowerCase()) || product.summary.toLowerCase().includes(value.toLowerCase()));
        }

        this.currentPage = 1;
        this.totalData = this.newsData.length
      },

      splitContent() {
        const parser = new DOMParser();
        const doc = parser.parseFromString(this.currentContent, 'text/html');
        const textNodes = doc.body.querySelectorAll('p, span, div');
        const imageNodes = doc.body.querySelectorAll('img[src^="data:image"]');

        // 首屏优先渲染文本内容
        const textContent = Array.from(textNodes)
          .map(el => el.outerHTML)
          .join('');

        // 图片内容延迟加载
        const imageContent = Array.from(imageNodes)
          .map(el => `<img data-src="${el.src}" class="lazy-img">`)
          .join('');

        this.currentContent = textContent + `<div class="image-container">${imageContent}</div>`;
      },

      startDrag(e) {
        // // 只有点击头部区域才能拖动
        // if (e.target.closest('.modal-header')) {
        //   this.isDragging = true
        //   this.startX = e.clientX
        //   this.startY = e.clientY
        //   this.startModalX = this.modalLeft
        //   this.startModalY = this.modalTop

        //   document.addEventListener('mousemove', this.onDrag)
        //   document.addEventListener('mouseup', this.stopDrag)
        // }
        this.isDragging = true
        this.startX = e.clientX
        this.startY = e.clientY
        this.startModalX = this.modalLeft
        this.startModalY = this.modalTop

        document.addEventListener('mousemove', this.onDrag)
        document.addEventListener('mouseup', this.stopDrag)
      },
      onDrag(e) {
        if (this.isDragging) {
          const dx = e.clientX - this.startX
          const dy = e.clientY - this.startY
          this.modalLeft = this.startModalX + dx
          this.modalTop = this.startModalY + dy
        }
      },
      stopDrag() {
        this.isDragging = false
        document.removeEventListener('mousemove', this.onDrag)
        document.removeEventListener('mouseup', this.stopDrag)
      }

    },
    mounted() {
      // this.setDefaultNode(1);
      this.getNewsTreeList();
      // 拆分内容：首屏非图片部分先渲染
      this.splitContent();
    },
    beforeDestroy() {
      // 组件销毁时移除事件监听
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.stopDrag)
    },
  };
</script>

<style scoped>
  @import '../../assets/css/main.css';


  .tree-line {
    background-color: transparent;
    color: #D3D3D2;
    min-height: 100vh;
  }

  ::v-deep .el-tree-node.is-current>.el-tree-node__content {
    background: #FCB42E !important;
    color: black;
  }

  /* ::v-deep .el-tree-node.is-current>.el-tree-node__content {
    background: #FCB42E !important;
    color: black;
  }

  ::v-deep .el-tree-node:focus>.el-tree-node__content {
    background-color: #FCB42E !important;
  } */

  /* ::v-deep .el-tree-node:has(.el-tree-node__children)>.el-tree-node__content {
    cursor: not-allowed;
  } */

  /* ::v-deep .el-tree-node:nth-child(1) > .el-tree-node__content {
    color: red;
  } */
  /* ::v-deep .el-tree-node:first-child>.el-tree-node__content {
    color: red;
  } */

  /* :deep(.el-tree-node) {
    background-color: transparent !important;
  }

  :deep(.el-tree) {
    background-color: transparent;
  }

  :deep(.el-tree-node__content:hover) {
    background-color: #FCB42E !important;
  }

  :deep(.el-tree-node:focus >.el-tree-node__content) {
    background-color: #FCB42E !important;
  }

  :deep(.el-tree--highlight-current .el-tree-node.is-current .el-tree-node__content) {
    background-color: #FCB42E !important;
  } */


  :deep(.page_search) {
    display: flex;
    justify-content: right;
  }

  :deep(.news_content) {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #353535;
  }

  :deep(.news_content:hover) {
    background-color: #171717;
  }

  :deep(.news_content_date) {
    padding: 4rem 0;
  }

  :deep(.news_content:hover .news_content_date) {
    background-color: #FCB42E;
  }

  :deep(.news_content_date_body) {
    padding: auto;
    color: #fff;
  }

  :deep(.news_content:hover .news_content_date_body) {
    color: #000;
  }

  :deep(.news_title) {
    color: #fff;
  }

  :deep(.news_content:hover .news_title) {
    color: #FCB42E;
  }

  :deep(.el-pagination.is-background .el-pager li:not(.disabled):not(.active)) {
    color: white !important;
    background-color: #434343;
  }

  :deep(.el-pagination.is-background .el-pager li:not(.disabled).active) {
    color: white;
    background-color: orange !important;
  }

  :deep(button.btn-prev) {
    background-color: #434343 !important;
  }

  :deep(button.btn-next) {
    background-color: #434343 !important;
  }

  :deep(button.btn-next, button .btn-prev, .el-pager li) {
    background-color: #434343 !important;
  }

  .popup {
    position: fixed;
    top: 53%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #424242;
    /* border: 1px solid #ccc; */
    border-bottom: 10px solid #262626;
    border-left: 10px solid #262626;
    border-right: 10px solid #262626;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 9999;
  }

  :deep(.ql-editor) {
    background-color: #424242 !important;
  }

  .trigger-div {
    padding: 20px;
    background: #424242;
    /* border: 1px solid #ccc; */
    cursor: pointer;
    text-align: center;
    margin: 20px;
  }

  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
  }

  .draggable-modal {
    position: absolute;
    background-color: #424242;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
    width: 60%;
    height: 100%;
    max-width: 1060px;
    min-width: 300px;
    min-height: 200px;
    cursor: move;
  }

  .modal-header {
    padding: 5px;
    background-color: #262626;
    color: white;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    cursor: move;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: none;
  }

  .close-btn {
    background: none;
    border: none;
    color: white;
    font-size: 20px;
    cursor: pointer;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .close-btn:hover {
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
  }

  .modal-content {
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 20px;
    height: calc(100% - 55px);
    border: none;
    overflow-x: auto;
    /* 隐藏水平溢出 */
    overflow-y: auto;
    /* 强制垂直滚动 */
    background-color: #424242;
  }

  .lazy-img {
    opacity: 0;
    transition: opacity 0.3s;
  }

  .lazy-img[data-loaded="true"] {
    opacity: 1;
  }
</style>